export type TypographyKeys =
  | "0"
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  | "custom";

export type TypographyProps = {
  fs?: TypographyKeys;
  fw?: "regular" | "medium" | "semibold" | "bold";
};

export type TypographyPropsKeys = keyof TypographyProps;
const typographyPropsKeys: TypographyPropsKeys[] = ["fs", "fw"];

export const createTypographyClasses = <TProps extends TypographyProps>(
  props: TProps,
) => {
  return typographyPropsKeys
    .map((key) => (props[key] ? `${key}-${props[key]}` : ""))
    .filter(Boolean);
};
